module.exports = __webpack_public_path__ + "static/media/icon-live-ic-add.f6a08460.svg";